import React, { useEffect } from "react";
import { SpotLight as SpotLightImpl, Object3D } from "three";
import { SpotLightConfig } from "../LightConfig";
import { applyShadowSettings } from "@/utils/shadow";

type Props = {
    config: SpotLightConfig;
    drawHelpers?: boolean;
};

export const SpotLight: React.FC<Props> = ({ config, drawHelpers }) => {
    const ref = React.useRef<SpotLightImpl>(null);
    const targetRef = React.useRef<Object3D>(null);

    useEffect(() => {
        if (ref.current) {
            applyShadowSettings(ref.current.shadow);
            ref.current.shadow.bias = 0.0002;
            ref.current.shadow.normalBias = 0.005;
        }
    }, [ref.current, config.angle]);

    return (
        <>
            <object3D ref={targetRef} position={config.target} />
            <spotLight
                ref={ref}
                position={config.position}
                target={targetRef.current ?? undefined}
                intensity={config.intensity}
                distance={config.distance}
                angle={config.angle}
                penumbra={config.penumbra}
                castShadow={config.castShadow}
            />
            <mesh visible={drawHelpers} position={config.position}>
                <sphereGeometry args={[0.1, 16, 16]} />
                <meshStandardMaterial color="yellow" />
            </mesh>
            <mesh visible={drawHelpers} position={config.target}>
                <sphereGeometry args={[0.1, 16, 16]} />
                <meshStandardMaterial color="red" />
            </mesh>
        </>
    );
};
